import React from 'react';
import { useResizeDetector } from 'react-resize-detector';
import { PageData } from '../../../../../interfaces/interfaces';
import { StageComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import PollNotification from '../../../../common/Poll/PollNotification';
import { TitleAndDescription } from '../../../pageBuilder/TitleAndDescription';
import GeneralStageVideo from '../GeneralVideo/GeneralVideo';
import PBModernMenu from './ModernMenu';

const withMenuComponent = (MenuComponent: React.FC<UiComponentElementInterface<StageComponentInterface>>): React.FC<StageElementInterface> => ({
  className,
  uiComponent,
}) => {
  const { height, ref } = useResizeDetector();

  const video = (stageSettingsProps?: Partial<PageData['stageSettings']>, className?: string, iFrameStyle?: any, showControls = true, autoPlay = false) => (
    <GeneralStageVideo
      style={{
        background: '#2a2a2a',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      }}
      //@ts-ignore
      stageSettings={{
        ...uiComponent.stageSettings,
        ...stageSettingsProps,
      }}
      isPlaying={uiComponent?.stageSettings?.autoplay || autoPlay}
      playerStyle={{ margin: 'auto' }}
      showControls={showControls}
      iFrameStyle={iFrameStyle}
      uiComponent={uiComponent}
      className={className}
    />
  );

  return (
    <>
      <TitleAndDescription component={uiComponent} />
      <div ref={ref} className={`flex flex-col @md:flex-row overflow-hidden w-full justify-center ${className ?? ''}`} style={{ minHeight: '100px' }}>
        {!uiComponent.stageSettings?.streamUrl &&
        !uiComponent.stageSettings?.livestream &&
        !uiComponent.stageSettings?.iFrame &&
        uiComponent.stageSettings?.streamType !== 'vystemStudio' ? (
          <div style={{ width: '100%', position: 'relative', height: 0, paddingTop: '56.25%' }}>
            {video(
              { streamUrl: 'https://stream.mux.com/Sqi02G28611pVJ83ZRAflX1te2200p31Jng01WWxNr00pHY.m3u8', streamType: 'url', autoplay: true },
              undefined,
              undefined,
              false,
              true
            )}
          </div>
        ) : (
          <>
            {(uiComponent.stageSettings.streamType === 'Youtube' ||
              uiComponent.stageSettings.streamType === 'Vimeo' ||
              uiComponent.stageSettings.streamType === 'url' ||
              uiComponent.stageSettings.streamType === 'vystemvideo' ||
              uiComponent.stageSettings.streamType === 'Vystemstream' ||
              uiComponent.stageSettings.streamType === 'vystemStudio' ||
              uiComponent.stageSettings.streamType === 'iFrame' ||
              uiComponent.stageSettings.streamType === 'media' ||
              uiComponent.stageSettings.streamType === 'videourl') && (
              <div style={{ width: '100%', position: 'relative', height: 0, paddingTop: '54.25%' }}>
                {video(undefined, 'flex justify-center items-center', {
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  width: '100%',
                  height: '100%',
                })}
              </div>
            )}
          </>
        )}
        <MenuComponent height={height} uiComponent={uiComponent} />
        <PollNotification />
      </div>
    </>
  );
};

interface StageElementInterface {
  className?: string;
  uiComponent: StageComponentInterface;
  height?: number;
}

const ModernMenuStage = withMenuComponent(PBModernMenu);
export const ModernStage: React.FC<StageElementInterface> = ({ className, uiComponent, height }) => (
  <ModernMenuStage className={className} uiComponent={uiComponent} height={height} />
);
